
import { defineComponent, PropType } from 'vue';

import Hamburger from '@/components/hamburger/index.vue';
import Fullscreen from '@/components/fullscreen/index.vue';
import Breadcrumb from '@/components/breadcrumb/index.vue';
import { IStoreAccount } from '@/store/account/type.d';
import { User } from '@element-plus/icons-vue';

const PAGE_HEADER = ['breadcrumb'];

export default defineComponent({
  name: 'AppHeader',
  components: {
    Hamburger,
    Fullscreen,
    Breadcrumb,
    User,
  },
  props: {
    accountData: {
      type: Object as PropType<IStoreAccount | null>,
      default: () => ({}),
    },
    opened: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const handleToggleSideBar = () => {
      emit('toggle-sidebar');
    };

    return {
      handleToggleSideBar,
      // 页面头部需要显示的内容
      pageHeader: PAGE_HEADER,
    };
  },
});
